/* eslint-disable no-unused-vars */
import React, { useEffect, useCallback } from 'react';
import { Tag,Button } from 'antd';
import useListFilters from '../../hooks/useListFilters';
import ListPage from '../../components/core/ListPage';
import {
  getInvoiceEmailSentStatusTagColor,
  getInvoicePaymentStatusTagColor,
  getInvoiceTypeText,
} from '../../utils/clinic';
import { getMonthTitleFromMonthNumber } from '../../utils/date';
import { useInvoicesReportList } from '../../hooks/invoice/useInvoicesReportList';
import InvoiceReportFilterForm from '../../components/Forms/buisness/InvoiceReportFilterForm';
const BREAD_CRUMBS = [
  { label: 'Invoice', to: '/user/invoicelist' },
  { label: 'Report', to: '/user/invoice-report-list' },
];

export const InvoicesReportList = () => {
  const { data, getList } = useInvoicesReportList();
  const {
    search,
    setSearch,
    pagination,
    setPagination,
    sortParams,
    setSortParams,
    loading,
    setLoading,
    selectedRows,
    setSelectedRows,
  } = useListFilters();
  const reload = useCallback(
    async (params) => {
      setLoading(true);
      try {
        const response = await getList({
          search,
          page: pagination.current,
          limit: pagination.pageSize,
          sortOrder: sortParams.sortOrder,
          sortBy: sortParams.sortField,
          doctorSub: params?.doctorSub,
          invoiceType: params?.invoiceType,
          invoiceMonth: params?.invoiceMonth,
          invoiceYear: params?.invoiceYear,
        });
        setLoading(false);
        setPagination({ total: response.totalItems });
      } catch (error) {
        setLoading(false);
      }
    },
    [
      pagination.current,
      pagination.pageSize,
      sortParams.sortOrder,
      sortParams.sortField,
      search,
    ]
  );

  const handleTableChange = (newPagination, _, sorter) => {
    const pageSizeChanged = newPagination?.pageSize !== pagination.pageSize;
    const nextPage = pageSizeChanged ? 1 : newPagination?.current || 1;
    setSortParams({
      sortOrder: Array.isArray(sorter) ? undefined : sorter.order,
      sortField: Array.isArray(sorter) ? undefined : sorter.field,
    });
    setPagination({ current: nextPage, pageSize: newPagination?.pageSize });
  };

  const handleSearch = (searchValue) => {
    setSearch(searchValue);
  };

  useEffect(() => {
    reload();
  }, [
    pagination.current,
    pagination.pageSize,
    sortParams.sortOrder,
    sortParams.sortField,
    search,
  ]);

  const handleSubmit = (values) => reload(values);
  const handleFormReset = () => reload();

  const columns = [
    {
      title: 'Invoice Type',
      dataIndex: 'invoiceType',
      sorter: true,
      render: (_, { invoiceType }) => {
        return invoiceType ? getInvoiceTypeText(invoiceType) : undefined;
      },
    },
    {
      title: 'Clinic Location',
      dataIndex: 'clinicLocationTitle',
      sorter: true,
    },
    {
      title: 'Clinic Owner',
      dataIndex: 'clinicAdminName',
      sorter: true,
    },
    {
      title: 'For Month',
      dataIndex: 'monthNumber',
      sorter: true,
      render: (_, { monthNumber }) => {
        return monthNumber >= 0
          ? getMonthTitleFromMonthNumber(monthNumber)
          : undefined;
      },
    },
    {
      title: 'For Year',
      dataIndex: 'yearNumber',
      sorter: true,
    },
    {
      title: 'Total Amount',
      dataIndex: 'amount',
      sorter: true,
    },
    {
      title: 'Payment Status',
      dataIndex: 'paymentId',
      render: (_, { paymentId }, index) => {
        let statusMeta = getInvoicePaymentStatusTagColor(paymentId);
        return (
          <Tag color={statusMeta?.color} key={index}>
            {statusMeta?.text}
          </Tag>
        );
      },
    },
    {
      title: 'Send Status',
      dataIndex: 'emailedStatus',
      render: (_, { emailedStatus }, index) => {
        let statusMeta = getInvoiceEmailSentStatusTagColor(emailedStatus);
        return (
          <Tag color={statusMeta?.color} key={index}>
            {statusMeta?.text}
          </Tag>
        );
      },
    },
  ];

  return (
    <>
      <ListPage
        title={'Invoice Report'}
        data={data?.items || []}
        columns={columns}
        loading={loading}
        pagination={pagination}
        rowKey={(record) => record?.invoiceId}
        onRefresh={reload}
        onSearch={handleSearch}
        onTableChange={handleTableChange}
        breadCrumbItems={BREAD_CRUMBS}
        hideAddAction
        secondaryExtraContent={
          <InvoiceReportFilterForm
            onSubmit={handleSubmit}
            onReset={handleFormReset}
          />
        }
        onSelectRowsfun={setSelectedRows}
      />
      {/* {(selectedRows && selectedRows.length > 0) &&
              <>
              <Button type="primary" className='m-2'
                  onClick={() => {
                    console.log('Assign: ');
                  } }>Assign Selected</Button>
                  <Button type="primary" danger onClick={() => {console.log('delete')} }>Delete Selected</Button></>} */}
    </>
  );
};
